
/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel';

require('./bootstrap');
window.Vue = require('vue');
window._ = require('lodash');

import vSelect from 'vue-select';
Vue.component('v-select', vSelect);

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i)
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key)))

// Vue.component('example-component', require('./components/ExampleComponent.vue'));

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

 const autocomplete = new Vue({
     el: '.autocomplete-tevekenyseg',
     data: {
         options: [],
         selected: { id: null, name: ''}
     },
     methods: {
       onSearch(search, loading) {
         if(search.length) {
           loading(true);
           this.search(loading, search, this);
         }
       },
       search: _.debounce((loading, search, vm) => {
            fetch(`/api/scopes`, {
               headers: {
                   "Content-Type": "application/json",
                   "Accept": "application/json, text-plain, */*",
                   "X-Requested-With": "XMLHttpRequest",
                },
                method: 'POST',
                credentials: "same-origin",
                body: JSON.stringify({q : search})
            }).then(res => {
               res.json().then(json => (vm.options = json));
               loading(false);
            });
       }, 350)
     }
 });

 
//Számláló
var section = document.querySelector('.szamlalo');
var hasEntered = false;

window.addEventListener('scroll', (e) => {
    var shouldAnimate = (window.scrollY + window.innerHeight) >= section.offsetTop;

    if (shouldAnimate && !hasEntered) {
        hasEntered = true;

        $('.szam').each(function () {
            $(this).prop('Counter', 0).animate({
                Counter: $(this).text()
            }, {
                duration: 4047,
                easing: 'swing',
                step: function (now) {
                    $(this).text(Math.ceil(now));
                }
            });
        });

    }
});

//Joci féle számláló
const counters = document.querySelectorAll('.value');
const speed = 200;

counters.forEach( counter => {
   const animate = () => {
      const value = +counter.getAttribute('akhi');
      const data = +counter.innerText;
     
      const time = value / speed;
     if(data < value) {
          counter.innerText = Math.ceil(data + time);
          setTimeout(animate, 1);
        }else{
          counter.innerText = value;
        }
     
   }
   
   animate();
});


//sticky header
/* window.addEventListener("scroll", function(){
    var header = document.querySelector("header");
    header.classList.toggle("sticky",window.scrollY > 0);
}) */

   
$(document).ready(function(){
    $('.owl-carousel-tamogatok').owlCarousel({
        loop:true,
        nav:true,
        navContainer: '#custom-control',
        responsive: {
            0: {
                items: 2     // Egy elemet jelenít meg mobil nézetben
            },
            576: {
                items:2
            },
            768:{
                items: 3
            },
            992: {
                items: 4     // Három elemet jelenít meg nagyobb nézetben (pl. laptop)
            },
            1200:{
                items:5
            }
        }
    });
});


$(document).ready(function(){
    $('.tortenetek-carousel').owlCarousel({
        //loop:true,
        nav:true,
        navContainer: '#custom-control',
        margin: 25,
        responsive: {
            0: {
                items: 1     // Egy elemet jelenít meg mobil nézetben
            },
            576: {
                items: 2
            },
            992: {
                items: 3     // Három elemet jelenít meg nagyobb nézetben (pl. laptop)
            },
            1200: {
                items: 3     // Három elemet jelenít meg nagyobb nézetben (pl. laptop)
            }
        }
    });
});


$(document).ready(function(){
    $('.hir-carousel').owlCarousel({
        //loop:true,
        nav:true,
        navContainer: '#custom-control',
        margin: 25,
        responsive: {
            0: {
                items: 1     // Egy elemet jelenít meg mobil nézetben
            },
            576: {
                items: 2
            },
            992: {
                items: 3     // Három elemet jelenít meg nagyobb nézetben (pl. laptop)
            },
            1200: {
                items: 3     // Három elemet jelenít meg nagyobb nézetben (pl. laptop)
            }
        }
    });
});

$(document).on("click", ".naccs .menu div", function() {
    var numberIndex = $(this).index();

    if (!$(this).is("active")) {
        $(".naccs .menu div").removeClass("active");
        $(".naccs ul li").removeClass("active");

        $(this).addClass("active");
        $(".naccs ul").find("li:eq(" + numberIndex + ")").addClass("active");

        var listItemHeight = $(".naccs ul")
            .find("li:eq(" + numberIndex + ")")
            .innerHeight();
        $(".naccs ul").height(listItemHeight + "px");
    }
});



// Navbar Dropdown Hover in Bootstrap v4
// https://stackoverflow.com/questions/42183672/how-to-implement-a-navbar-dropdown-hover-in-bootstrap-v4
$('.dropdown-hoverable').hover(function(){
    $(this).children('[data-toggle="dropdown"]').click();
}, function(){
    $(this).children('[data-toggle="dropdown"]').click();
});

//mobile overlay nav
var btn = $('#mobile-nav-trigger');
var cls = $('#mobile-nav-close');
var nav = $('#navbarOverlayMobile');

$(btn).click(function(){
    $(nav).slideDown("slow");
    $(btn).hide();
    $(cls).show();
});

$(cls).click(function(){
    $(nav).slideUp("slow");
    $(btn).show();
    $(cls).hide();
});

jQuery(document).on('click', '.confirm', function() {
    return confirm('Biztos benne?');
});

$(function() {
    $('.disable-on-click').click(function(){
        var button = $(this);
        setTimeout(function () {
            button.attr('disabled', 'disabled');
        }, 100);
    });
});




